export class DataLayerWrapper {
  static push(params: object) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(params);
  }
}
